import type { LiveViewActivity } from "../types";
import { liveViewActivityText } from "../liveViewActivity";

export const LiveViewActivityNote = ({
  activity
}: {
  activity: LiveViewActivity;
}) => {
  const { title, detail } = liveViewActivityText(activity);

  return (
    <div className="space-y-1">
      <p className="text-base font-bold text-content-1000">{title}</p>
      {detail ? (
        <p className="text-sm font-normal text-content-400">{detail}</p>
      ) : null}
    </div>
  );
};
